import { render, staticRenderFns } from "./Logradouro.vue?vue&type=template&id=f6414fbc&"
import script from "./Logradouro.vue?vue&type=script&lang=js&"
export * from "./Logradouro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports